import {action, computed, observable} from 'mobx';
import {types, endpoints} from 'main/tools';
import {NotificationRecipient, AssignmentRule} from 'main/stores/documents';
import {DomainStore} from 'shared/store';
import {User} from 'main/stores/users';
import {Employee} from 'main/stores/employees';
import _ from 'lodash';

class EmployeeDocumentState {
  store = new DomainStore();

  @observable document;
  @observable users = [];
  @observable employees = [];

  @action async load(){
    await this.store._compose([
      endpoints.USERS.ACTIVE,
      endpoints.EMPLOYEES.ALL
    ]);

    this.users = this.store._getAll(types.USER, User);
    this.employees = this.store._getAll(types.EMPLOYEE, Employee);
  }

  receiveProps({document}) {
    this.document = document;
  }

  @computed get recipientOptions() {
    return [
      new NotificationRecipient({
        recipientType: 'manager'
      }),
      ...this.users.map(user => new NotificationRecipient(
        {
          recipientType: 'specific_user',
          user: user
        }
      ))
    ];
  }

  @computed get ruleOptions() {
    const ruleOptions = [];
    const order = this.document.assignmentRules.length;

    if (!_.some(this.document.assignmentRules, {assigneeType: 'manager'})) {
      ruleOptions.push(new AssignmentRule({
        assigneeType: 'manager',
        order
      }));
    }

    const existingIds = _.map(this.document.assignmentRules, 'employee.id');
    const availableEmployees = _.filter(this.employees, (employee) => !_.includes(existingIds, employee.id));

    ruleOptions.push(...availableEmployees.map((employee) => new AssignmentRule(
      {
        assigneeType: 'specific_employee',
        employee,
        order
      }
    )));

    return ruleOptions;
  }
}

export default EmployeeDocumentState;
